
(function(global) {
	'use strict';
	
	/* 繧ｹ繝励�繝ｳ繝輔Ν繝ｯ繝ｳ - 險倅ｺ九�繝ｼ繧ｸ script.js */
	const NSO = window.NSO;
	
	document.addEventListener('DOMContentLoaded', function() {
      	addDecoration();
		addBgCloud();
		refNote();
		insertRelation();
		articleOpen();
		NSO.onLoaded([
			NSO.modalContentsUi,
			// addBgCloud,
			// addDecoration,
			// refNote,
			// insertRelation,
			NSO.anchorScroll
		]);
		NSO.internalLinkEffect(articleOpen);
		
		if (document.querySelector('path') !== null) setPathLen();
	});
	window.addEventListener('resize', function() {
		NSO.onResize(function() {
			if (deco.masterData !== undefined) deco.refresh();
		});
	});
	
	/* MEMO: stroke-dasharray 縺ｨ stroke-dashoffset 縺ｮ繧ｹ繧ｿ繧､繝ｫ繧堤函謌舌☆繧� */
	function setPathLen() {
		const path = document.querySelectorAll('path[class]');
		let d = [];
		path.forEach(function(e) {
			const len = e.getTotalLength() * 10;
			d.push({ c: e.classList[0], l: Math.round(len) / 10 + 1 });
		});
		let style = '';
		for (let i in d) {
			style += '.' + d[i].c + '{stroke-dasharray:' + d[i].l + 'px ' + d[i].l + 'px;';
			style += 'stroke-dashoffset:-' + d[i].l + 'px}';
		}
		console.log(style);
	}
	
	/**
	 * opening
	 -------------------------------------------------- */
	function articleOpen() {
		if (document.querySelector('.article_intro') !== null) op.constructor();
	}
	const op = {
		constructor: function() {
			this.introElm = document.getElementsByClassName('article_intro')[0];
			this.introDeco = document.getElementsByClassName('decoration_intro')[0];
			imagesLoaded('.article_intro', this.introLoaded);
			//this.introLoaded();
		},
		introLoaded: function() {
			op.introElm.classList.add('is-open');
			op.introElm.classList.add('is-opening');
			op.introElm.addEventListener('transitionend', op.introEnd);
			op.introDeco.classList.add('is-open');
			op.introDeco.classList.add('is-opening');
			op.introDeco.addEventListener('animationend', op.decoEnd);
		},
		// 陌ｹ縺梧怙蠕�
		introEnd: function(e) {
			if (e.target.className.animVal === 'c5') {
				this.classList.remove('is-opening');
				this.removeEventListener('transitionend', op.introEnd);
			}
		},
		// 繝溘Ν繧ｯ縺梧怙蠕�
		decoEnd: function(e) {
			//console.dir(e.target.className);
			if (e.target.className === '-milk') {
				console.log(this);
				this.classList.remove('is-opening');
				this.removeEventListener('animationend', op.decoEnd);
			}
		}
	};
	
	/**
	 * addBgCloud
	 -------------------------------------------------- */
	function addBgCloud() {
		if (document.querySelector('.js-bgcloud') !== null) abc.constructor();
	}
	const abc = {
		constructor: function() {
			const elms = document.getElementsByClassName('js-bgcloud');
			for (let i = elms.length; i--;) {
				this.setup(elms[i]);
			}
		},
		setup: function(elm) {
			const length = elm.dataset['cloud'];
			let html = '<div class="deco-bgcloud">';
			for (let i = 0; i < length; i++) {
				html += '<svg width="62" height="34" viewBox="0 0 62 34" class="svg-cloud c' + (i+1) + '"><use href="#deco-cloud"/></svg>';
			}
			html += '</div>';
			elm.insertAdjacentHTML('afterbegin', html);
		}
	};
	
	/**
	 * 閼壽ｳｨ [data-ref] 縺ｨ [data-note] 縺ｮ陦後″譚･
	 * refNote();
	 -------------------------------------------------- */
	function refNote() {
		if (document.querySelector('[data-ref]') !== null) rn.constructor();
	}
	const rn = {
		refArray: {},
		constructor: function() {
			const ref = document.querySelectorAll('[data-ref]');
			const note = document.querySelectorAll('[data-note]');
			
			for (let i = 0, len = ref.length; i< len; i++) {
				this.refDatalize(ref[i], ref[i].dataset['ref']);
				ref[i].firstChild.addEventListener('click', this.onClick)
			}
			//console.log(this.refArray);
			for (let i = 0, len = note.length; i < len; i++) {
				this.createNoteLink(note[i], note[i].dataset['note']);
			}
		},
		/* 閼壽ｳｨ逡ｪ蜿ｷ縺ｫ id 莉倅ｸ弱＠縺ｦ閼壽ｳｨ縺ｸ縺ｮ繝ｪ繝ｳ繧ｯ險ｭ鄂ｮ */
		refDatalize: function(elm, id) {
			// 蜷後§閼壽ｳｨ逡ｪ蜿ｷ縺ｫ縺ｯ _n 騾｣逡ｪ繧剃ｻ倅ｸ�
			if (this.refArray['cite_ref-' + id] === undefined) {
				this.refArray['cite_ref-' + id] = [];
			}
			this.refArray['cite_ref-' + id].push('note');
			elm.id = 'cite_ref-' + elm.dataset['ref'] + '_' + this.refArray['cite_ref-' + id].length;
			
			elm.removeAttribute('data-ref');
			elm.innerHTML = '<a href="#cite_note-' + id + '" class="js-anc">' + elm.innerHTML + '</a>';
		},
		/* 閼壽ｳｨ縺ｫ繧� id 莉倅ｸ弱＠縺ｦ縲√＞縺｣縺溘ｓ荳逡ｪ荳翫�閼壽ｳｨ逡ｪ蜿ｷ縺ｸ縺ｮ繝ｪ繝ｳ繧ｯ險ｭ鄂ｮ */
		createNoteLink: function(elm, id) {
			elm.innerHTML = '<span id="cite_note-' + id + '">' + elm.innerHTML + '</span>';
			elm.insertAdjacentHTML('afterbegin', '<sup><a href="#cite_ref-' + id + '_1" class="js-anc">^</a></sup>');
		},
		/* 閼壽ｳｨ逡ｪ蜿ｷ繧偵け繝ｪ繝�け縺励◆繧峨∵ｳｨ驥医� href 繧呈嶌縺肴鋤縺医ｋ */
		onClick: function(e) {
			const noteElm = document.getElementById(this.getAttribute('href').slice(1));
			const refAnchor = noteElm.parentNode.getElementsByClassName('js-anc')[0];
			refAnchor.href = '#' + this.parentNode.id;
		}
	};
	
	/**
	 * decoration
	 -------------------------------------------------- */
	function addDecoration() {
		if (document.querySelector('.js-decoration') !== null) deco.constructor();
	}
	const deco = {
		constructor: function() {
			const container = document.getElementsByClassName('js-decoration')[0];
			this.section = container.children;
			this.refresh();
			
			NSO.setInview(function() {
				NSO.pulldownUi();
				setTimeout(NSO.transformScroll, 60);
			});
			NSO.insistentRefreshFns.push(function() {
				deco.refresh();
			});
			
			if (location.hash || NSO.getParam().hash) {
				const hash = location.hash ? location.hash.slice(1) : NSO.getParam().hash;
				setTimeout(function() {
					NSO.pd.pullOpen(NSO.pd.pullData[hash + '-inner'])
				}, 400);
			}
		},
		positionSetup: function(elm) {
			this.masterData = {
				offset: document.getElementById(elm.dataset['id']).offsetTop,
				height: document.getElementById(elm.dataset['id']).clientHeight
			}
			elm.style.top = this.masterData.offset + this.masterData.height + 'px';
		},
		refresh: function() {
			for (let i = 0, len = this.section.length; i < len; i++) {
				this.positionSetup(this.section[i]);
			}
		}
	};


  	/**
	 * 初めて医療従事者へ進む時
	 -------------------------------------------------- */
	function forhealthcareworkersLink() {
		if (location.href.indexOf('forhealthcareworkers') === -1) {
			if (document.querySelector('.is-fhw') !== null) fhw.constructor();
		}
	}
	const fhw = {
		constructor: function() {
			if (sessionStorage.getItem('fhw') !== 'passed') {
				const fhwLinks = document.getElementsByClassName('is-fhw');
				this.fhwUrl = fhwLinks[0].href;
              　　console.log(this.fhwUrl);
				this.createDialog();
				for (let i = fhwLinks.length; i--;) {
					fhwLinks[i].addEventListener('click', this.openDialog);
				}
			}
			// TEST
			document.querySelector('.character').addEventListener('click', function() {
				sessionStorage.removeItem('fhw');
			});
		},
		openDialog: function(e) {
			e.preventDefault();
			document.body.classList.remove('is-fixed');
			fhw.dialog.classList.add('is-anim');
			fhw.dialog.classList.add('is-active');
			fhw.dialog.addEventListener('transitionend', fhw.openEnd);
		},
		openEnd: function(e) {
			if (e.propertyName === 'transform') {
				this.removeEventListener('transitionend', fhw.openEnd);
			}
		},
		createDialog: function() {
			let dialog = '';
			dialog += '<div class="p-confirmation l-dialog">';
			dialog += '<div class="bg"></div>';
			dialog += '<div class="dialog_panel">';
			dialog += '<h2 class="title">あなたは医療従事者ですか？</h2>';
			dialog += '<div class="answer">';
			dialog += '<a href="' + this.fhwUrl + '" class="c-button">はい</a>';
			dialog += '<button type="button" class="c-button js-closeDialog" aria-label="注意事項を閉じる">いいえ</button>';
			dialog += '</div>';
			dialog += '<button type="button" class="close js-closeDialog" aria-label="注意事項を閉じる"><svg width="24" height="24" viewBox="0 0 8 8"><use href="#ico-close"/></svg></button>';
			dialog += '</div>';
			dialog += '</div>';
			document.body.insertAdjacentHTML('beforeend', dialog);
			this.dialog = document.getElementsByClassName('p-confirmation')[0];
			
			const link = this.dialog.querySelector('[href="' + this.fhwUrl + '"]');
			link.addEventListener('click', this.linkToAccess);
			
			const close = this.dialog.getElementsByClassName('js-closeDialog');
			for (let i = close.length; i--;) {
				close[i].addEventListener('click', this.toClose);
			}
		},
		linkToAccess: function(e) {
			e.preventDefault();
			sessionStorage.setItem('fhw', 'passed');
			fhw.dialog.classList.remove('is-active');
			location.href = fhw.fhwUrl;
		},
		toClose: function() {
			fhw.dialog.classList.remove('is-active');
			fhw.dialog.addEventListener('transitionend', fhw.closeEnd);
		},
		closeEnd: function(e) {
			if (e.target.className.indexOf('bg') >= 0) {
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', fhw.closeEnd);
				document.body.classList.remove('is-fixed');
			}
		}
	};

  
	/**
	 * relation
	 -------------------------------------------------- */
	function insertRelation() {
		if (document.querySelector('.js-relation') !== null) relation.constructor();
	}
	const relation = {
		constructor: function() {
			// let html = '';
			// const elm = document.getElementsByClassName('js-relation');
			// const elm = document.querySelector('.js-relation');
			// const data = NSO.siteData.article.contents;
			// const currentPage = elm.dataset.page;
			// html += '<div class="c-relationlist js-inview" data-ivanim=".item:last-child a">';
			// for (let i in data) {
			// 	html += this.returnItem(data[i], currentPage);
			// }
			// html += '</div>';
			// elm.innerHTML = html;
			
            // const slider = document.getElementsByClassName('c-relationlist');
            const slider = document.querySelector('.c-relationlist');
			this.slider = new Flickity(slider, {
				contain: true,
				pageDots: false,
				groupCells: true,
				arrowShape: 'M76,86,20,50,76,14'
			});
			NSO.setInview();

          　　// 記事のアニメーションクラスの追加
            const target = document.querySelector('.js-relation');
            const targetAddClass = document.querySelector('.c-relationlist');
            window.addEventListener('scroll', function () {
              const scroll = window.scrollY;
              const windowHeight = window.innerHeight;
              const targetPos = target.getBoundingClientRect().top + scroll;
                if (scroll > targetPos - windowHeight) { 
                  targetAddClass.classList.add('is-anim');
                }
            });
          
		}
		// returnItem: function(d, cur) {
		// 	let html = '';
		// 	if (cur === d.page) {
		// 		html += '<div class="item -cur"><a href="../' + d.page + '/" class="c-linkpanel -v" aria-current="page">';
		// 	} else {
		// 		html += '<div class="item"><a href="../' + d.page + '/" class="c-linkpanel -v">';
		// 	}
		// 	html += '<figure class="image"><img src="../img/relation_' + d.page + '.jpg" alt="" width="316" height="194"></figure>';
		// 	html += '<p class="text ' + d.color + '">';
		// 	html += '<span class="main">' + d.title + '</span>';
		// 	html += '<svg width="18" height="18" viewBox="0 0 18 18" class="ico">';
		// 	html += '<path d="M9,18A9,9,0,1,0,0,9,9,9,0,0,0,9,18ZM6.338,5.866a.7.7,0,1,1,.82-1.128L13.022,9,7.158,13.262a.69.69,0,0,1-.409.133.7.7,0,0,1-.411-1.261L10.65,9Z"/>';
		// 	html += '</svg>';
		// 	html += '</p>';
		// 	html += '</a></div>';
		// 	return html;
		// }
	};

})((this || 0).self || global);